export function index(applicationId)
{
    return axios.get(route('api.manage.applications.documents', { applicationId }))
        .then((response) => {return response.data});
}

export function store(applicationId, data)
{
    return axios.post(route('api.manage.applications.documents.store', {applicationId}), data)
        .then(response => response.data);
}

export function update(documentId, data)
{
    return axios.patch(route('api.manage.documents.update', { documentId: documentId }), data)
        .then(response => response.data);
}

export function destroy(documentId)
{
    return axios.delete(route('api.manage.documents.destroy', { documentId: documentId }));
}
